// This file contains Content Types for Contentful page models
/* ExtraPages array creates pages unique to a locale like Homepage or Search Page.
   If any of these pages have a contentful query associated to it, then associatedQuery
   key should be added with the contentType value for that template.
   For example, Homepage has a query associated to it, so its contentType value passed in
   associatedQuery. Please make sure you keep the contentType value and the associatedQuery value in
   sync to avoid any problems.
   
   Schema for Extra Pages = [
     {
       name: "Any relevant name",
       path: Provide a valid path that you want to see in browser. If the path contains the locale, 
             use /{locale} in the appropriate place. Eg: Search page = /{locale}/search.
       actualPath: The actual url to the NextJS template Page. Eg: Search Page = /search if search.js
                   is in root of pages folder. This value is also kept in sync with the slugs in the file 
                   ./pageTemplateSlugs. Please keep these files in sync.
       associatedQuery: Provide contentType of page which has any contentful Query associated to it.
                        Eg: If Home Page, then use the contentType value of homepage in associated Query.
                        If the page has no associated query, pass blank string                   
     }
   ]

   Remember that these pages by default use slug as 'index' 
   (Which has no significance, just helps with static export).
 */

module.exports = {
  contentType: {
    contentPage: 'contentPage',
    productPage: 'productPage',
    newProductPage: 'newProductPage',
    articleListPage: 'articleListPage',
    articlePage: 'articlePage',
    productListPage: 'productListPage',
    writeReviewPage: 'writeReview',
    homePage: 'homePage',
    login: 'loginPage',
    countrySelectorPage: 'countrySelector',
    registrationPage: 'registrationPage',
    layout: 'layout',
    urlBuilder: 'urlBuilder',
    siteMap: 'siteMap',
    createPassword: 'createPassword',
    forgotPassword: 'forgotPassword',
    editProfile: 'editProfile',
  },
  contentfulConstant: 'Contentful',
  staticDataFolderName: 'static-data-source',
  gaPageViewsFileName: 'GAPageViews',
  bazaarVoiceFileName: 'bvReviews',
  urlBuilderFileName: 'urlBuilder',
  productsFileName:'products',
  articlesFileName:'articles',
  productDetailsDescription: 'BENEFÍCIOS',
  FAQ_TITLE: "Perguntas Frequentes",
  Hidden_H1_TXT: "Descubra a nova linha Molecular Bond Repair, que regenera e reconstrói até 98% dos danos.",
  pageTypes: {
    HOME: 'Home',
    PRODUCT: 'Product',
    ARTICLE: 'Brand Experience Topic',
    CONTENT_PAGE: 'Brand Experience Topic',
    PRODUCT_LISTING: 'Product Listing',
    ARTICLE_LISTING: 'Article Listing',
    LOGIN: 'Login',
    REGISTRATION: 'Registration',
    CREATEPASSWORD: 'CreatePassword',
    FORGOTPASSWORD: 'ForgotPassword',
    EDITPROFILE: 'EditProfile',
  },
  // This array creates one page for each locale instance in a project.
  extraPages: [
    {
      path: '/{locale}',
      name: 'HomePage',
      actualPath: '/homepage',
      associatedQuery: 'homePage',
      publishedOn: '2020-06-25T12:56:08Z',
    },
    {
      path: '/{locale}/404',
      name: 'ErrorPage',
      actualPath: '/_error',
      associatedQuery: '',
    },
    {
      path: '/{locale}/contacte-nos',
      name: 'ContactUs',
      actualPath: '/faq-contact',
      associatedQuery: '',
      publishedOn: '2020-06-25T12:56:08Z',
    },
    {
      path: '/{locale}/mapa-do-site',
      name: 'SiteMap',
      actualPath: '/siteMap',
      associatedQuery: 'siteMap',
      publishedOn: '2020-06-25T12:56:08Z',
    },
    {
      path: '/{locale}/search-results',
      name: 'SearchPage',
      actualPath: '/SearchPage',
      associatedQuery: '',
    },
    {
      path: '/{locale}/childrejectionpage',
      name: 'childrejection',
      actualPath: '/janrain-pages/ChildRejection',
      associatedQuery: '',
      publishedOn: '2020-06-29T12:56:08Z',
    },

  ],
  pageSlug: {
    home: {
      breadCrumbTitle: 'Home',
    },
    'hair-biology': {
      breadCrumbTitle: 'Hair Biology',
    },
    'write-review': {
      breadCrumbTitle: 'Write Review',
    },
    contactus: {
      breadCrumbTitle: 'Contact us',
    },
    sitemap: {
      breadCrumbTitle: 'Sitemap',
    },
    search: {
      breadCrumbTitle: 'Search',
    },
    'terms-and-conditions': {
      breadCrumbTitle: 'Braun & EA Gaming Promotion Terms & Conditions',
    },
    'silk-expert-3-ipl': {
      breadCrumbTitle: 'Silk-épil 3 epilator',
    },

    middleSection: "middleSection",
      //userinstruction
      none: "none",
      leftwrapper: "left-wrapper",
      rightwrapper: "right-wrapper",
      slideText: "slideText",
      slideSection: "slideSection",
      slideImage: "slideImage",
      ContentTypeRichText: "ContentTypeRichText",
      DynamicRichText: "DynamicRichText",
  },
  navigationHeaders: {
    SOBRE_NOS: 'SOBRE NOS',
    NOVIDADES: 'NOVIDADES',
    DEFAULT_SUBMENU_ARIA_LABEL: 'menu button subMenu',
    SOBRE_NOS_DEFAULT_COUNT: 5,
    NOVIDADES_DEFAULT_COUNT: 3,
    getAriaLabel: (name, count) => `${name.toLowerCase()} button with list of ${count} items menu button subMenu`,
  },
  filterHeaders: {
    TIPO_DE_CABELO: 'TIPO DE CABELO',
    NECESSIDADE_DO_CABELO: 'NECESSIDADE DO CABELO',
    TIPO_DE_PRODUTO: 'TIPO DE PRODUTO',
    COLECOES: 'COLECOES',
  },
};
